import React from "react";
import { Nav } from "shards-react";

import SidebarNavItem from "./SidebarNavItem";
import { Store } from "../../../flux";
import CheckPermission from "../../checkPermission/CheckPermission";

class SidebarNavItems extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      navItems: Store.getSidebarItems()
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    Store.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      ...this.state,
      navItems: Store.getSidebarItems()
    });
  }

  render() {
    const { navItems: items } = this.state;
    return (
      <div className="nav-wrapper">
        <Nav className="nav--no-borders flex-column">
          {items.map((item, idx) => {
            if (item.subMenu) {
              return (
                <CheckPermission key={idx} resource={item.permission.resource} action={[item.permission.action]} group={item.permission.group}>
                  <ul className="sub-nav">
                    <li>{item.title}</li>
                    {item.items.map((item, idx) => (
                      <CheckPermission key={idx} resource={item.permission.resource} action={[item.permission.action]} group={item.permission.group}>
                        <SidebarNavItem  item={item} />
                      </CheckPermission>
                    ))}
                  </ul>
                </CheckPermission>
              )
            } else {
              return (
                <CheckPermission key={idx} resource={item.permission.resource} action={[item.permission.action]} group={item.permission.group}>
                  <SidebarNavItem item={item} />
                </CheckPermission>
              )
            }
          })}
        </Nav>
      </div>
    )
  }
}

export default SidebarNavItems;
